import { render } from "./WrapHeader.vue?vue&type=template&id=47097884&scoped=true"
import script from "./WrapHeader.vue?vue&type=script&lang=js"
export * from "./WrapHeader.vue?vue&type=script&lang=js"

import "./WrapHeader.vue?vue&type=style&index=0&id=47097884&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-47097884"

export default script